import RightTimeApi from "@/API";
import type { LanguageLike } from "@/utils/languageUtils";
import { getTranslationLocale } from "@/utils/languageUtils";
import { apiMessage } from "@/utils/apiMessage";

export async function translateTextAsync(
  text: string,
  sourceLocale: string,
  targetLocale: string
): Promise<string> {
  if (!text?.trim()) return "";

  const resp = await RightTimeApi.postAsync("/Translate", {
    text,
    sourceLocale,
    targetLocale,
  });

  if (!resp?.ok) {
    throw new Error(apiMessage(resp, "Translation request failed"));
  }

  const translated = String(resp?.jsonData?.translatedText ?? resp?.jsonData?.TranslatedText ?? "").trim();
  if (!translated) throw new Error("Translation response was empty");
  return translated;
}

export async function translateFromEnglishAsync(
  text: string,
  targetLanguage: LanguageLike | null | undefined,
  sourceLanguage: LanguageLike | null | undefined = { abbrev: "eng", ietf: "en" }
): Promise<string> {
  return translateTextAsync(
    text,
    getTranslationLocale(sourceLanguage, "en"),
    getTranslationLocale(targetLanguage, "en")
  );
}
